/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Row_UntitledInputs */

const vi_shop_home_row_untitled = /** @type {(inputs: Shop_Home_Row_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(chưa có tiêu đề)`)
};

/**

* @param {Shop_Home_Row_UntitledInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_row_untitled = /** @type {((inputs?: Shop_Home_Row_UntitledInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Row_UntitledInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_row_untitled(inputs)
});